<nav id="nav-primary">
  <ul class="nav nav-tabs nav-fill text-uppercase">
    @if (clientAttributes !== undefined && hasRDOAccess) {
      <li class="nav-item">
        <a class="nav-link" routerLink="summary" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          id="{{'main.tabs.summary.page_title' | rdoPathToId}}">
          <i class="fa fa-fw fa-home"></i>&nbsp; {{'main.tabs.summary.page_title' | translate}}
        </a>
      </li>
    }

    <!-- Watchlist -->
    <li class="nav-item" style="display: none;">
      <div class="fake-tab"></div>
      <a href="#" class="nav-link" id="{{'main.navigation.watchlists' | rdoPathToId}}">
        <i class="fa fa-fw fa-eye"></i>&nbsp; {{'main.navigation.watchlists' | translate}}
        <span class="badge bg-success ms-3">
          <i class="fa fa-long-arrow-up"></i>&nbsp; 0.00
        </span>
      </a>
    </li>

    <!-- Geography -->
    @if (clientAttributes !== undefined && !clientAttributes?.IsTrial && hasRDOAccess) {
      <li class="nav-item dropdown geo-list" id="geography-dropdown" routerLinkActive="active"
        >
        <a class="nav-link dropdown-toggle geo-link"
          (click)="displayGeoDropdown = !displayGeoDropdown">
          <i class="fa fa-fw fa-globe" aria-hidden="true"></i>&nbsp;
          {{"main.tabs.geography.title" | translate}}
        </a>
        <ul class="dropdown-menu geo-ul" [class.show]="displayGeoDropdown">
          <li id="regions-list-item" (click)="displayGeoDropdown = !displayGeoDropdown" class="geo-li">
            <a routerLink="regions" class="dropdown-item">
              <i class="fa fa-fw fa-globe" aria-hidden="true"></i>&nbsp;
              {{'main.tabs.geography.regions.title' | translate}}
            </a>
          </li>
          <li id="districts-list-item" (click)="displayGeoDropdown = !displayGeoDropdown" class="geo-li">
            <a routerLink="districts" class="dropdown-item">
              <i class="fa fa-fw fa-road" aria-hidden="true"></i>&nbsp;
              {{'main.tabs.geography.districts.title' | translate}}
            </a>
          </li>
          <li id="branches-list-item" (click)="displayGeoDropdown = !displayGeoDropdown" class="geo-li">
            <a routerLink="branches" class="dropdown-item">
              <i class="fa fa-fw fa-university" aria-hidden="true"></i>&nbsp;
              {{'main.tabs.geography.branches.title' | translate}}
            </a>
          </li>
        </ul>
      </li>
    }

    @if (clientAttributes !== undefined && clientAttributes?.IsTrial && hasRDOAccess) {
      <li class="nav-item"
        id="geography-dropdown">
        <div class="fake-tab"></div>
        <a class="nav-link fake-anchor">
          <i class="fa fa-fw fa-globe" aria-hidden="true"></i>&nbsp;
          {{"main.tabs.geography.title" | translate}} <span class="caret"></span>
        </a>
      </li>
    }

    <!-- Sales Reps -->
    @if (clientAttributes !== undefined && !clientAttributes?.IsTrial && hasRDOAccess) {
      <li class="nav-item" id="sales-reps-list-item"
        >
        <a routerLink="sales-reps" class="nav-link" routerLinkActive="active">
          <i class="fa fa-fw fa-user"></i>&nbsp;
          {{"main.tabs.sales_reps.sales_reps" | translate}}
        </a>
      </li>
    }

    @if (clientAttributes !== undefined && clientAttributes?.IsTrial && hasRDOAccess) {
      <li class="nav-item" id="sales-reps-list-item"
        >
        <div class="fake-tab"></div>
        <a class="nav-link fake-anchor">
          <i class="fa fa-fw fa-user"></i>&nbsp;
          {{"main.tabs.sales_reps.sales_reps" | translate}}
        </a>
      </li>
    }

    <!-- Customers -->
    @if (clientAttributes !== undefined && !clientAttributes?.IsTrial && hasRDOAccess) {
      <li class="nav-item" id="customers-list-item"
        >
        <a routerLink="customers" class="nav-link" routerLinkActive="active">
          <i class="fa fa-fw fa-building"></i>&nbsp;
          {{"main.tabs.customers.customers" | translate}}
        </a>
      </li>
    }

    @if (clientAttributes !== undefined && clientAttributes?.IsTrial && hasRDOAccess) {
      <li class="nav-item" id="customers-list-item"
        >
        <div class="fake-tab"></div>
        <a class="nav-link fake-anchor">
          <i class="fa fa-fw fa-building"></i>&nbsp;
          {{"main.tabs.customers.customers" | translate}}
        </a>
      </li>
    }

    <!-- Equipment -->
    @if (clientAttributes !== undefined && !clientAttributes?.IsTrial && hasAssetGrid && hasRDOAccess) {
      <li class="nav-item dropdown equipment-dropdown-list" id="equipment-dropdown" routerLinkActive="active"
        style="user-select: none;"
        >
        <a (click)="displayEquipmentDropdown = !displayEquipmentDropdown"
          class="nav-link dropdown-toggle equipment-dropdown-link">
          <rdo-category-icon
            [category]="gear"
            class="equipment-icon" />
          &nbsp; {{"main.tabs.equipment.title" | translate}}
        </a>
        <ul class="dropdown-menu equipment-dropdown-container" [class.show]="displayEquipmentDropdown">
          <li id="equipment-list-item" (click)="displayEquipmentDropdown = !displayEquipmentDropdown">
            <a routerLink="equipment" class="dropdown-item">
              <img src="/assets/images/icons/gear.svg" alt="Gear Icon" class="gear-icon">
              &nbsp; {{'main.core.common.counts.product_types.plural' | translate}}
            </a>
          </li>
          <li id="rental-assets-list-item" (click)="displayEquipmentDropdown = !displayEquipmentDropdown">
            <a routerLink="rental-assets" class="dropdown-item">
              <i class="fa fa-fw fa-tags" aria-hidden="true"></i>
              &nbsp; {{'main.tabs.equipment.rental_assets.title' | translate}}
            </a>
          </li>
        </ul>
      </li>
    }

    @if (clientAttributes !== undefined && !clientAttributes?.IsTrial && !hasAssetGrid && hasRDOAccess) {
      <li class="nav-item" id="equipment-list-item"
        >
        <a routerLink="equipment" class="nav-link" routerLinkActive="active">
          <rdo-category-icon [category]="gear"></rdo-category-icon>&nbsp;
          {{"main.tabs.equipment.title" | translate}}
        </a>
      </li>
    }

    @if (clientAttributes !== undefined && clientAttributes?.IsTrial && hasRDOAccess) {
      <li class="nav-item" id="equipment-list-item"
        >
        <div class="fake-tab"></div>
        <a class="nav-link fake-anchor">
          <rdo-category-icon [category]="gear"></rdo-category-icon>&nbsp;
          {{"main.tabs.equipment.title" | translate}}
        </a>
      </li>
    }

    @if (authenticationService._userInfoView.HasClientAccessToDownloads) {
      <li id="downloads-list-item"
        class="nav-item">
        <a routerLink="downloads" class="nav-link" routerLinkActive="active">
          <i class="fa fa-fw fa-download"></i>&nbsp;
          {{"main.tabs.downloads.title" | translate}}
        </a>
      </li>
    }

    @if (authenticationService.hasAccessToCustomGrids(showCustomGrids, clientAttributes?.IsTrial)) {
      <li
        id="custom-grids-list-item" class="nav-item">
        <a routerLink="custom-grids" class="nav-link" routerLinkActive="active">
          <i class="fa fa-fw fa-cog"></i>&nbsp;
          {{"main.tabs.custom_grids.title" | translate}}
        </a>
      </li>
    }
  </ul>
</nav>
